import React, { useMemo } from "react";
import { Card, Row, Col, Table, Statistic, Tag } from "antd";
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
import { PieChart, Pie, Cell, ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, LineChart, Line, Legend } from "recharts";
import Dashboard from "./components/Dashboard";

const COLORS = ["#00C49F", "#FF8042"];

const BDEAnalyticsDashboard = () => {
    const data = useMemo(
        () => ({
            overall: {
                yearlyTarget: 12000000,
                yearlyAchieved: 9500000,
                quarterlyTarget: 3000000,
                quarterlyAchieved: 2200000,
                monthlyTarget: 1000000,
                monthlyAchieved: 750000,
                revenue: 8700000,
                profit: 2000000,
                salesAchieved: 850,
                salesMissed: 150,
                activeBDEs: 10,
                conversionRate: (850 / 1000) * 100,
            },
            bdePerformance: [
                { key: 1, name: "John Doe", target: 500000, achieved: 450000, revenue: 420000 },
                { key: 2, name: "Jane Smith", target: 600000, achieved: 300000, revenue: 280000 },
                { key: 3, name: "David Johnson", target: 550000, achieved: 560000, revenue: 550000 },
                { key: 4, name: "Sophia Brown", target: 400000, achieved: 390000, revenue: 380000 },
                { key: 5, name: "Michael Lee", target: 450000, achieved: 200000, revenue: 190000 },
            ],
            monthlyTrend: [
                { month: "Jan", target: 1000000, achieved: 850000 },
                { month: "Feb", target: 1200000, achieved: 900000 },
                { month: "Mar", target: 1500000, achieved: 1200000 },
                { month: "Apr", target: 1300000, achieved: 1100000 },
            ],
        }),
        []
    );

    // const pieData = [
    //     { name: "Achieved", value: data.overall.salesAchieved },
    //     { name: "Missed", value: data.overall.salesMissed },
    // ];

    const columns = [
        { title: "BDE Name", dataIndex: "name", key: "name" },
        { title: "Target (₹)", dataIndex: "target", key: "target" },
        { title: "Achieved (₹)", dataIndex: "achieved", key: "achieved" },
        {
            title: "Performance",
            render: (_: any, record: any) => (
                <Tag color={record.achieved >= record.target ? "green" : "red"}>
                    {((record.achieved / record.target) * 100).toFixed(1)}%
                </Tag>
            ),
        },
        { title: "Revenue (₹)", dataIndex: "revenue", key: "revenue" },
    ];

    // High and Low Performers
    const highPerformers = data.bdePerformance
        .filter((bde) => bde.achieved >= bde.target)
        .map((bde) => bde.name);
    const lowPerformers = data.bdePerformance
        .filter((bde) => bde.achieved < bde.target * 0.6)
        .map((bde) => bde.name);

    return (
        <div >

            <Dashboard />


            {/* <Row gutter={16} className="mt-4">
                <Col span={6}>
                    <Card>
                        <Statistic title="Monthly Target" value={data.overall.monthlyTarget} suffix="₹" />
                    </Card>
                </Col>
                <Col span={6}>
                    <Card>
                        <Statistic title="Monthly Achieved" value={data.overall.monthlyAchieved} suffix="₹" />
                    </Card>
                </Col>
                <Col span={6}>
                    <Card>
                        <Statistic title="Sales Achieved" value={data.overall.salesAchieved} />
                    </Card>
                </Col>
                <Col span={6}>
                    <Card>
                        <Statistic title="Conversion Rate" value={data.overall.conversionRate.toFixed(1)} suffix="%" />
                    </Card>
                </Col>
            </Row> */}

            {/* Charts */}
            {/* <Row gutter={16} className="mt-6">
                <Col span={12}>
                    <Card title="Sales Achieved vs Missed">
                        <ResponsiveContainer width="100%" height={250}>
                            <PieChart>
                                <Pie data={pieData} cx="50%" cy="50%" innerRadius={60} outerRadius={90} paddingAngle={5} dataKey="value" label>
                                    {pieData.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                </Pie>
                            </PieChart>
                        </ResponsiveContainer>
                    </Card>
                </Col>
                <Col span={12}>
                    <Card title="Monthly Target vs Achieved">
                        <ResponsiveContainer width="100%" height={250}>
                            <BarChart data={data.monthlyTrend}>
                                <XAxis dataKey="month" />
                                <YAxis />
                                <Tooltip />
                                <Legend />
                                <Bar dataKey="target" fill="#8884d8" />
                                <Bar dataKey="achieved" fill="#82ca9d" />
                            </BarChart>
                        </ResponsiveContainer>
                    </Card>
                </Col>
            </Row> */}

            {/* High & Low Performers */}
            {/* <Row gutter={16} className="mt-6">
                <Col span={12}>
                    <Card title="High Performing BDEs">
                        {highPerformers.length ? highPerformers.join(", ") : "No high performers yet"}
                    </Card>
                </Col>
                <Col span={12}>
                    <Card title="Low Performing BDEs">
                        {lowPerformers.length ? lowPerformers.join(", ") : "No low performers"}
                    </Card>
                </Col>
            </Row> */}

            {/* BDE Performance Table */}
            <Card className="mt-6" title="BDE Performance">
                <Table columns={columns} dataSource={data.bdePerformance} pagination={false} />
            </Card>
        </div >
    );
};

export default BDEAnalyticsDashboard;
